import { Action, createReducer, on } from '@ngrx/store';
import { addPlansetData, addPlansetDataFailure, addPlansetDataSuccess, cancelPlansetRecord, cancelPlansetRecordFailure, cancelPlansetRecordSuccess, clearPlansetData, createHoldRecord, createHoldRecordFailure, createHoldRecordSuccess, createPlansetCommentRecord, createPlansetCommentRecordSuccess, createRevisionRecord, createRevisionRecordSuccess, editPlansetData, editPlansetDataFailure, editPlansetDataSuccess, fetchPlansetAttachments, fetchPlansetAttachmentsFailure, fetchPlansetAttachmentsSuccess, fetchPlansetCancelReasonsList, fetchPlansetCancelReasonsListSuccess, fetchPlansetMembersList, fetchPlansetMembersListSuccess, fetchPlansetRecordComments, fetchPlansetRecordCommentsFailure, fetchPlansetRecordCommentsSuccess, fetchPlansetRecordRevisions, fetchPlansetRecordRevisionsFailure, fetchPlansetRecordRevisionsSuccess, fetchPlansetRecordholdunhold, fetchPlansetRecordholdunholdFailure, fetchPlansetRecordholdunholdSuccess, fetchPlansetsListData, fetchPlansetsListFailure, fetchPlansetsListSuccess, fetchSinglePlansetRecordData, fetchSinglePlansetRecordDataFailure, fetchSinglePlansetRecordDataSuccess, updatePlansetStatus, updatePlansetStatusFailure, updatePlansetStatusSuccess } from "./planset.actions";
import { PlansetModel } from '../../core/models/planset.models';
import { TimelineModel } from '../../core/models/timeline.models';
import { CommentModel } from '../../core/models/comments.models';
import { RevisionModel } from '../../core/models/revisions.models';
import { HoldModel } from '../../core/models/hold.model';
import { ProjectTeamModel } from '../../core/models/projectteam.model';

export interface PlansetState {
    tabid: number;
    plansets: PlansetModel[];
    loading: boolean;
    error: any;
    isadded: boolean;
    timelines: TimelineModel[];
    plansetrecord: any;
    comments: CommentModel[];
    revisions: RevisionModel[];
    holdunhold: HoldModel[];
    teammembers: ProjectTeamModel[];
    jobcancelreasons: any;
    attachments: any[]
}

export const initialState: PlansetState = {
    tabid: 1,
    plansets: [],
    loading: true,
    error: null,
    isadded: false,
    timelines: [],
    plansetrecord: null,
    comments: [],
    revisions: [],
    holdunhold: [],
    teammembers: [],
    jobcancelreasons: null,
    attachments: []
};

export const PlansetReducer = createReducer(
    initialState,

    // Plan Set Vendor
    on(fetchPlansetsListData, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchPlansetsListSuccess, (state, { Plansets: plansets, tabid: tabid }) => {
        return { ...state, plansets, loading: false, tabid: tabid };
    }),
    on(fetchPlansetsListFailure, (state, { error, tabid: tabid }) => {
        return { ...state, error, loading: false, tabid: tabid };
    }),

     // Add Plan Set
     on(addPlansetData, (state) => {
        return { ...state, loading: true, error: null, isadded: false };
    }),
    on(addPlansetDataSuccess, (state) => {
        return { ...state, isadded: true, loading: false };
    }),
    on(addPlansetDataFailure, (state, { error }) => {
        return { ...state, error, loading: false, isadded: false };
    }),

    // fetch Plan Set
    on(fetchSinglePlansetRecordData, (state) => {
        return { ...state, loading: true, error: null, isadded: false };
    }),
    on(fetchSinglePlansetRecordDataSuccess, (state, { plansetrecord: plansetrecord }) => {
        return { ...state, isadded: true, loading: false, plansetrecord };
    }),
    on(fetchSinglePlansetRecordDataFailure, (state, { error }) => {
        return { ...state, error, loading: false, isadded: false };
    }),
    on(clearPlansetData, () => {
        return { ...initialState };
    }),

    // Put Plan Set
    on(updatePlansetStatus, (state) => {
        return { ...state, loading: true, error: null, isadded: false };
    }),
    on(updatePlansetStatusSuccess, (state) => {
        return { ...state, loading: false, isadded: true };
    }),
    on(updatePlansetStatusFailure, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

    // Get Comments
    on(fetchPlansetRecordComments, (state) => {
        return { ...state, loading: true, error: null, isadded: false };
    }),
    on(fetchPlansetRecordCommentsSuccess, (state, { comments: comments }) => {
        return { ...state, loading: false, comments };
    }),
    on(fetchPlansetRecordCommentsFailure, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

    // Get Revisions
    on(fetchPlansetRecordRevisions, (state) => {
        return { ...state, loading: true, error: null, isadded: false };
    }),
    on(fetchPlansetRecordRevisionsSuccess, (state, { revisions: revisions }) => {
        return { ...state, loading: false, revisions };
    }),
    on(fetchPlansetRecordRevisionsFailure, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

    // Get Hold/Unhold Records
    on(fetchPlansetRecordholdunhold, (state) => {
        return { ...state, loading: true, error: null, isadded: false };
    }),
    on(fetchPlansetRecordholdunholdSuccess, (state, { holdunhold: holdunhold }) => {
        return { ...state, loading: false, holdunhold };
    }),
    on(fetchPlansetRecordholdunholdFailure, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

     // PUT REQUEST ON HOLD
     on(createHoldRecord, (state) => {
        return { ...state, loading: true, error: null};
    }),
    on(createHoldRecordSuccess, (state, { holdrecord }) => {
        return { ...state, loading: false, error: null, holdunhold: holdrecord };
    }),

    // PUT REQUEST REVISION
    on(createRevisionRecord, (state) => {
        return { ...state, loading: true, error: null};
    }),
    on(createRevisionRecordSuccess, (state) => {
        return { ...state, loading: false, error: null };
    }),

    // CREATE PLANSET COMMENT RECORD
    on(createPlansetCommentRecord, (state) => {
        return { ...state, loading: true, error: null};
    }),
    on(createPlansetCommentRecordSuccess, (state, { comment }) => {
        return { ...state, loading: false, error: null, comments: comment };
    }),

    // FETCH PLANSET COMMENT RECORD
    on(fetchPlansetMembersList, (state) => {
        return { ...state, loading: true, error: null};
    }),
    on(fetchPlansetMembersListSuccess, (state, { memberslist }) => {
        return { ...state, loading: false, error: null, teammembers: memberslist };
    }),

    // FETCH JOB CANCEL REASONS
    on(fetchPlansetCancelReasonsList, (state) => {
        return { ...state, error: null};
    }),
    on(fetchPlansetCancelReasonsListSuccess, (state, { reasons }) => {
        return { ...state, error: null, jobcancelreasons: reasons };
    }),
    // CANCEL PLANSET RECORD
    on(cancelPlansetRecord, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(cancelPlansetRecordSuccess, (state) => {
        return { ...state, loading: false };
    }),
    on(cancelPlansetRecordFailure, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

    // PLANSET ATTACHMENTS
    on(fetchPlansetAttachments, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchPlansetAttachmentsSuccess, (state, { attachments}) => {
        return { ...state, loading: false, attachments};
    }),
    on(fetchPlansetAttachmentsFailure, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

     // Edit Plan Set
     on(editPlansetData, (state) => {
        return { ...state, loading: true, error: null, isadded: false };
    }),
    on(editPlansetDataSuccess, (state) => {
        return { ...state, isadded: true, loading: false };
    }),
    on(editPlansetDataFailure, (state, { error }) => {
        return { ...state, error, loading: false, isadded: false };
    }),
);

// Selector
export function reducer(state: PlansetState | undefined, action: Action) {
    return PlansetReducer(state, action);
}
